// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/styles/async/" + {2418: "66a36e55",3736: "936dd943",8840: "acc0fc28",}[chunkId] + ".css"
}